import { Box, Button } from '@mui/material';
import styled from 'styled-components';

export const SearchInputWrapper = styled(Box)(() => ({
  display: 'flex',
  gap: 16,
  alignItems: 'center',
  flexWrap: 'wrap',
  width: '100%',
}));

export const ButtonWrapper = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  marginTop: 24,
  gap: 16,
  flexDirection: 'row',
  flexWrap: 'wrap',
}));

export const HeaderWrapper = styled(Box)(() => ({
  maxWidth: '95%',
  marginInline: 'auto',
  marginBlock: 32
}));

export const RoundedButton = styled(Button).attrs({
  variant: 'contained',
  color: 'primary'
})({
  width: '100%',
  borderRadius: '6px !important',
  '@media (min-width:600px)': {
    width: 'auto'
  }
});
